import { MetlAmpService } from '@weave/schema-gen-ts/dist/schemas/messaging/etl/amp/v1/service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaMetlAmp = bindHTTP(MetlAmpService);
